import { useState, useContext } from 'react';
import { TextField, Button, Typography, Grid, Box, Paper, } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

import { supabase } from '../supabaseClient';
import { CurrProfileContext } from '../App/App.tsx';

const SignIn = ()  => {
  const nav = useNavigate();
  const { _p, _set, updateProfile } = useContext(CurrProfileContext);
  const [formData, setFormData] = useState({ email: '', password: '', });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    supabase.auth.signInWithPassword({ 
      email: formData.email, 
      password: formData.password 
    }).then((res) => {
      if(res.error) {
        console.error("Failed to login: " + res.error.message)
      } else {
        updateProfile();
        nav("/profile");
      }
    })
  };

  return (
    <Grid container sx={{ flex: '1', width: '100%', margin: 'auto' }} >
      <Paper elevation={10} sx={{ height: '100%', width: '100%', margin: '0 4vw' }} >
        <Box sx={{
          m: "2vh 2vw",
          display: 'flex', flexDirection: 'column', alignItems: 'center',
        }}>
          <Typography component="h1" variant="h4" sx={{ mt: 0}}>
            Sign In
          </Typography>
          <Box component="form" onSubmit={handleSubmit} sx={{ flex: '1', mt: 3, pl: 4, pr: 4  }}>
            <Grid container spacing={2}>
              <Grid item xs={20} style={{ width: '100%'}}>
                <TextField required fullWidth
                  id="email" label="Email Address"
                  name="email" type="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={20} style={{ width: '100%'}}>
                <TextField required fullWidth
                  name="password" label="Password"
                  type="password" id="password"
                  value={formData.password}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>

            <Button type="submit" fullWidth variant="contained" sx={{m: "2vh 0" }}>
              Sign In
            </Button>
            <Grid container justifyContent="flex-end">
              <Grid item sx={{ mb: '2vh' }}>
                <Link to="/sign_up" variant="body2">
                  Don't have an account? Sign Up
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box> 
      </Paper>
    </Grid>
  );
}
export default SignIn;